var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVitD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 450 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.1741 95.6216L89.5922 75.2035L151.194 136.805L130.775 157.223L69.1741 95.6216Z",
    fill: "#FF6378"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3964 181.417H93.1897V210.297H22.3964V181.417Z",
    fill: "#FF6378"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.41 28.4033H204.29V99.1967H175.41V28.4033Z",
    fill: "#FF6378"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195.73 228.403L105.877 318.256C86.3278 298.708 54.6321 298.708 35.0833 318.256C15.5345 337.805 15.5345 369.501 35.0833 389.05C43.935 397.901 55.2771 402.731 66.8541 403.567L131.609 353.252L207.804 262.616L195.73 228.403Z",
    fill: "#FFCFBC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.066 274.691L207.804 262.616L66.8541 403.567C67.6897 415.144 72.5193 426.487 81.371 435.337C100.92 454.886 132.616 454.886 152.164 435.337C171.713 415.789 171.713 384.093 152.164 364.544L229.765 286.944L212.066 274.691Z",
    fill: "#FFB89B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M368.629 14.6621C349.08 -4.88671 317.384 -4.88671 297.836 14.6621C278.287 34.2109 278.287 65.9066 297.836 85.4554L220.235 163.056L237.934 175.309L242.196 187.383L328.75 119.53L383.146 46.4329C382.31 34.8559 377.481 23.5128 368.629 14.6621Z",
    fill: "#FFCFBC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M414.917 60.9501C406.065 52.0984 394.723 47.2687 383.145 46.4331L242.196 187.383L254.27 221.596L344.123 131.743C363.672 151.292 395.368 151.292 414.917 131.743C434.466 112.195 434.466 80.4989 414.917 60.9501Z",
    fill: "#FFB89B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitD);
export default __webpack_public_path__ + "static/media/VitD.20873a4e.svg";
export { ForwardRef as ReactComponent };